/* istanbul ignore file */
import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { CardMode } from '@components/card/card.component';
import { MdsTextFieldComponent } from '@medpacesoftwaredevelopment/designsystem';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { FormGroupValueOf } from '@utility/utility';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';

export class RentalCarPreferencesFormGroup extends PersistentFormGroup<{
    frequentTravelerNumber: PersistentFormControl<string>;
}> {
    public static create(value: FormGroupValueOf<RentalCarPreferencesFormGroup>): RentalCarPreferencesFormGroup {
        return new RentalCarPreferencesFormGroup({
            frequentTravelerNumber: new PersistentFormControl(value.frequentTravelerNumber, [
                notWhitespaceValidator(),
                maxLengthValidator(100),
            ]),
        });
    }
}
@Component({
    selector: 'medpace-car-rental-preferences',
    templateUrl: './car-rental-preferences.component.html',
    styleUrls: ['./car-rental-preferences.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MdsTextFieldComponent],
})
export class CarRentalPreferencesComponent {
    public readonly formGroup: InputSignal<RentalCarPreferencesFormGroup> =
        input.required<RentalCarPreferencesFormGroup>();
    public readonly mode: InputSignal<CardMode> = input.required<CardMode>();
}
